// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23999%27 stroke-width=%272%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Google Fonts */

/* ==========================================================================
   EVENTS DESIGN SYSTEM - Official, Minimalist & Theme-Aware
   ========================================================================== */

:root {
  /* Minimalist Official Palette - Dark Mode Default */
  --ev-primary: #2563eb;
  --ev-primary-hover: #1d4ed8;
  --ev-primary-muted: rgba(37, 99, 235, 0.12);
  --ev-purple: #4f46e5;
  --ev-purple-glow: rgba(79, 70, 229, 0.15);
  --ev-blue: #2563eb;
  --ev-teal: #0d9488;
  --ev-orange: #d97706;
  --ev-green: #059669;
  --ev-red: #dc2626;
  
  /* Domain colors */
  --domain-aiml: #4f46e5;
  --domain-web: #2563eb;
  --domain-design: #0d9488;
  --domain-security: #059669;
  --domain-programming: #d97706;
  
  /* Category backgrounds */
  --cat-hackathon: #4f46e5;
  --cat-ctf: #059669;
  --cat-workshop: #2563eb;
  --cat-contest: #d97706;
  --cat-paper: #64748b;
}

[data-theme='light'] {
  --ev-primary: #0f172a;
  --ev-primary-hover: #1e293b;
  --ev-primary-muted: rgba(15, 23, 42, 0.06);
  --ev-purple: #3b82f6;
  --ev-purple-glow: rgba(59, 130, 246, 0.12);
}

.events-page {
  min-height: 100vh;
  background: #f7f7f4 !important;
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #171a24 !important;
}

.events-wrapper {
  max-width: 1160px;
  margin: 0 auto;
  padding: 1.5rem;
}

/* ==========================================================================
   CARDS & CONTAINERS
   ========================================================================== */

.match-card {
  background: var(--glass-bg);
  backdrop-filter: blur(12px);
  border: 1px solid var(--glass-border);
  border-radius: 16px;
  padding: 1.25rem 1.5rem;
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.match-card:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 255, 255, 0.18);
  box-shadow: 0 12px 24px -6px rgba(0, 0, 0, 0.35);
}

[data-theme='light'] .match-card {
  background: #ffffff;
  border-color: #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

[data-theme='light'] .match-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.08);
}

/* ==========================================================================
   PILLS & BADGES
   ========================================================================== */

.match-score-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.25rem 0.65rem;
  border-radius: 10px;
  font-size: 0.78rem;
  font-weight: 600;
  background: rgba(37, 99, 235, 0.12);
  border: 1px solid rgba(37, 99, 235, 0.25);
  color: #93c5fd;
}

[data-theme='light'] .match-score-pill {
  color: #1d4ed8;
  background: #eff6ff;
  border-color: #bfdbfe;
}

.alumni-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.2rem 0.6rem;
  border-radius: 8px;
  font-size: 0.72rem;
  font-weight: 600;
  background: rgba(217, 119, 6, 0.12);
  border: 1px solid rgba(217, 119, 6, 0.25);
  color: #fbbf24;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

[data-theme='light'] .alumni-badge {
  background: #fffbeb;
  border-color: #fde68a;
  color: #b45309;
}

.activity-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.2rem 0.6rem;
  border-radius: 8px;
  font-size: 0.72rem;
  font-weight: 600;
  border: 1px solid transparent;
}

.activity-badge.hackathon {
  background: rgba(99, 102, 241, 0.12);
  border-color: rgba(99, 102, 241, 0.25);
  color: #c7d2fe;
}
.activity-badge.ctf {
  background: rgba(16, 185, 129, 0.12);
  border-color: rgba(16, 185, 129, 0.25);
  color: #a7f3d0;
}
.activity-badge.workshop {
  background: rgba(59, 130, 246, 0.12);
  border-color: rgba(59, 130, 246, 0.25);
  color: #bfdbfe;
}
.activity-badge.contest {
  background: rgba(245, 158, 11, 0.12);
  border-color: rgba(245, 158, 11, 0.25);
  color: #fde68a;
}
.activity-badge.paper {
  background: rgba(148, 163, 184, 0.12);
  border-color: rgba(148, 163, 184, 0.25);
  color: #cbd5e1;
}

[data-theme='light'] .activity-badge.hackathon {
  background: #eef2ff;
  border-color: #c7d2fe;
  color: #4338ca;
}
[data-theme='light'] .activity-badge.ctf {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #065f46;
}
[data-theme='light'] .activity-badge.workshop {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1e40af;
}
[data-theme='light'] .activity-badge.contest {
  background: #fffbeb;
  border-color: #fde68a;
  color: #b45309;
}
[data-theme='light'] .activity-badge.paper {
  background: #f8fafc;
  border-color: #e2e8f0;
  color: #475569;
}

/* ==========================================================================
   BUTTONS
   ========================================================================== */

.ev-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1.6rem;
  border-radius: 12px;
  border: 1px solid transparent;
  background: var(--ev-primary);
  color: #ffffff;
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

.ev-btn-primary:hover {
  background: var(--ev-primary-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

[data-theme='light'] .ev-btn-primary {
  background: #0f172a;
  color: #ffffff;
}

[data-theme='light'] .ev-btn-primary:hover {
  background: #1e293b;
}

.ev-btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 1.4rem;
  border-radius: 12px;
  border: 1px solid var(--glass-border);
  background: var(--glass-bg);
  color: var(--text-main);
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ev-btn-secondary:hover {
  background: var(--glass-hover);
  transform: translateY(-1px);
}

[data-theme='light'] .ev-btn-secondary {
  background: #ffffff;
  border-color: #e2e8f0;
  color: #1e293b;
}

.ev-connect-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 1.1rem;
  border-radius: 10px;
  font-size: 0.84rem;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  background: var(--ev-primary);
  color: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

.ev-connect-btn:hover {
  background: var(--ev-primary-hover);
  transform: translateY(-1px);
}

[data-theme='light'] .ev-connect-btn {
  background: #0f172a;
  color: #ffffff;
}

[data-theme='light'] .ev-connect-btn:hover {
  background: #1e293b;
}

.ev-connect-btn.pending {
  background: rgba(255, 255, 255, 0.06);
  color: var(--text-secondary);
  border: 1px solid var(--glass-border);
  box-shadow: none;
  cursor: default;
}

.ev-connect-btn.connected {
  background: rgba(16, 185, 129, 0.12);
  color: #10b981;
  border: 1px solid rgba(16, 185, 129, 0.25);
  box-shadow: none;
  cursor: default;
}

[data-theme='light'] .ev-connect-btn.connected {
  background: #ecfdf5;
  color: #065f46;
  border-color: #a7f3d0;
}

.ev-connect-btn.pending:hover,
.ev-connect-btn.connected:hover {
  transform: none;
}

/* ==========================================================================
   STATUS BADGES
   ========================================================================== */

.ev-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.25rem 0.75rem;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ev-status-badge.live {
  background: rgba(16, 185, 129, 0.12);
  border: 1px solid rgba(16, 185, 129, 0.3);
  color: #34d399;
}

.ev-status-badge.live::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #10b981;
}

.ev-status-badge.upcoming {
  background: rgba(59, 130, 246, 0.12);
  border: 1px solid rgba(59, 130, 246, 0.3);
  color: #93c5fd;
}

.ev-status-badge.completed {
  background: rgba(148, 163, 184, 0.12);
  border: 1px solid rgba(148, 163, 184, 0.3);
  color: #cbd5e1;
}

[data-theme='light'] .ev-status-badge.live {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #065f46;
}

[data-theme='light'] .ev-status-badge.upcoming {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1e40af;
}

[data-theme='light'] .ev-status-badge.completed {
  background: #f1f5f9;
  border-color: #e2e8f0;
  color: #475569;
}

/* ==========================================================================
   HERO & LANDING PAGE COMPONENTS
   ========================================================================== */

.ev-hero {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  min-height: 270px;
  display: flex;
  align-items: flex-end;
  padding: 2.25rem;
  background: linear-gradient(135deg, #090d16 0%, #111827 100%);
  border: 1px solid var(--glass-border);
}

[data-theme='light'] .ev-hero {
  border-color: #e2e8f0;
}

.ev-hero-img {
  position: absolute;
  inset: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  opacity: 0.35;
}

.ev-hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(9, 13, 22, 0.94) 0%, rgba(9, 13, 22, 0.45) 60%, transparent 100%);
}

.ev-hero-content {
  position: relative;
  z-index: 2;
}

.ev-hero-title {
  font-size: clamp(1.8rem, 3.5vw, 2.75rem);
  font-weight: 800;
  color: #ffffff;
  line-height: 1.15;
  margin-bottom: 0.5rem;
  letter-spacing: -0.02em;
}

.ev-hero-sub {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.82);
  margin-bottom: 0.5rem;
  max-width: 820px;
  line-height: 1.5;
}

/* Minimalist metadata strip */
.ev-meta-bar {
  display: flex;
  gap: 2rem;
  padding: 1.15rem 1.5rem;
  background: var(--glass-bg);
  border-radius: 14px;
  margin: 1.75rem 0;
  border: 1px solid var(--glass-border);
  flex-wrap: wrap;
}

[data-theme='light'] .ev-meta-bar {
  background: #ffffff;
  border-color: #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.ev-meta-item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 0.92rem;
  font-weight: 500;
  color: var(--text-main);
}

.ev-meta-icon {
  color: var(--text-secondary);
  flex-shrink: 0;
}

/* Minimalist Join Networking CTA Card */
.ev-cta-card {
  text-align: center;
  padding: 3rem 1.5rem;
  background: var(--glass-bg);
  border-radius: 20px;
  border: 1px solid var(--glass-border);
  margin-top: 1rem;
}

[data-theme='light'] .ev-cta-card {
  background: #ffffff;
  border-color: #e2e8f0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
}

.ev-cta-card h2 {
  font-size: 1.55rem;
  font-weight: 700;
  margin-bottom: 0.6rem;
  color: var(--text-main);
  letter-spacing: -0.01em;
}

.ev-cta-card p {
  color: var(--text-secondary);
  font-size: 0.95rem;
  max-width: 580px;
  margin: 0 auto 1.75rem;
  line-height: 1.5;
}

/* ==========================================================================
   NAVIGATION & TABS
   ========================================================================== */

.category-anchors {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding: 0.75rem 1.5rem;
  scrollbar-width: none;
  position: sticky;
  top: 0;
  z-index: 50;
  backdrop-filter: blur(20px);
  background: rgba(15, 15, 30, 0.85);
  border-bottom: 1px solid var(--glass-border);
  margin: 0 -1.5rem;
}

.category-anchors::-webkit-scrollbar {
  display: none;
}

[data-theme='light'] .category-anchors {
  background: rgba(255, 255, 255, 0.9);
  border-bottom-color: #e2e8f0;
}

.anchor-pill {
  flex-shrink: 0;
  padding: 0.4rem 1rem;
  border-radius: 10px;
  border: 1px solid var(--glass-border);
  background: transparent;
  color: var(--text-secondary);
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.anchor-pill:hover {
  background: var(--glass-hover);
  color: var(--text-main);
}

.anchor-pill.active {
  background: var(--ev-primary);
  border-color: var(--ev-primary);
  color: white;
}

[data-theme='light'] .anchor-pill.active {
  background: #0f172a;
  border-color: #0f172a;
}

.ev-tab-nav {
  display: flex;
  gap: 0;
  border-radius: 10px;
  background: var(--glass-bg);
  padding: 0.25rem;
  border: 1px solid var(--glass-border);
}

[data-theme='light'] .ev-tab-nav {
  background: #f1f5f9;
  border-color: #e2e8f0;
}

.ev-tab-btn {
  flex: 1 1;
  padding: 0.5rem 0.75rem;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--text-muted);
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.ev-tab-btn.active {
  background: var(--ev-primary);
  color: white;
}

[data-theme='light'] .ev-tab-btn.active {
  background: #0f172a;
  color: white;
}

/* ==========================================================================
   MODAL & FORMS
   ========================================================================== */

.ev-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  box-sizing: border-box;
}

.ev-modal {
  width: 100%;
  max-width: 640px;
  max-height: 90vh;
  margin: auto;
  background: #0f172a;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.6);
  position: relative;
}

[data-theme='light'] .ev-modal {
  background: #ffffff;
  border-color: #e2e8f0;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
}

.ev-modal-header {
  padding: 1.25rem 1.75rem;
  background: transparent;
  border-bottom: 1px solid var(--glass-border);
  flex-shrink: 0;
}

[data-theme='light'] .ev-modal-header {
  border-bottom-color: #e2e8f0;
}

.ev-modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.5rem 1.75rem;
  scrollbar-width: thin;
  scrollbar-color: var(--glass-border) transparent;
}

.ev-modal-footer {
  padding: 1rem 1.75rem 1.25rem;
  border-top: 1px solid var(--glass-border);
  flex-shrink: 0;
}

[data-theme='light'] .ev-modal-footer {
  border-top-color: #e2e8f0;
}

.ev-input {
  width: 100%;
  padding: 0.7rem 0.9rem;
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: 10px;
  color: var(--input-text);
  font-size: 0.9rem;
  transition: all 0.2s;
  box-sizing: border-box;
}

.ev-input:focus {
  outline: none;
  border-color: var(--ev-primary);
  box-shadow: 0 0 0 2px var(--ev-primary-muted);
}

.ev-input::placeholder {
  color: var(--input-placeholder);
}

.ev-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem center;
  padding-right: 2.5rem;
}

.ev-label {
  display: block;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 0.4rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.ev-form-group {
  margin-bottom: 1.15rem;
}

.ev-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

@media (max-width: 480px) {
  .ev-form-row {
    grid-template-columns: 1fr;
  }
}

.ev-pill-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.ev-pill {
  padding: 0.35rem 0.8rem;
  border-radius: 8px;
  border: 1px solid var(--glass-border);
  background: var(--glass-bg);
  color: var(--text-secondary);
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.ev-pill:hover {
  border-color: var(--ev-primary);
  color: var(--text-main);
}

.ev-pill.selected {
  background: var(--ev-primary-muted);
  border-color: var(--ev-primary);
  color: var(--text-main);
  font-weight: 600;
}

[data-theme='light'] .ev-pill {
  background: #ffffff;
  border-color: #e2e8f0;
}

[data-theme='light'] .ev-pill.selected {
  background: #eff6ff;
  border-color: #93c5fd;
  color: #1e40af;
}

.ev-progress-steps {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ev-step-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--glass-border);
  transition: all 0.3s;
}

.ev-step-dot.active {
  background: var(--ev-primary);
  width: 20px;
  border-radius: 4px;
}

.ev-step-dot.done {
  background: var(--ev-primary);
}

.ev-tag-input-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  padding: 0.5rem;
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: 10px;
  min-height: 44px;
  cursor: text;
  transition: border-color 0.2s;
}

.ev-tag-input-wrapper:focus-within {
  border-color: var(--ev-primary);
  box-shadow: 0 0 0 2px var(--ev-primary-muted);
}

.ev-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.2rem 0.55rem;
  background: var(--ev-primary-muted);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  color: var(--text-main);
  font-size: 0.78rem;
  font-weight: 500;
}

[data-theme='light'] .ev-tag {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1e40af;
}

.ev-tag button {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  opacity: 0.7;
}

.ev-tag button:hover {
  opacity: 1;
}

.ev-tag-input {
  border: none;
  background: transparent;
  color: var(--input-text);
  font-size: 0.85rem;
  outline: none;
  flex: 1 1;
  min-width: 80px;
  padding: 0.1rem 0.3rem;
}

.ev-tag-input::placeholder {
  color: var(--input-placeholder);
}

.skill-split {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 0.5rem;
  align-items: center;
  background: var(--glass-bg);
  border-radius: 10px;
  padding: 0.75rem;
  border: 1px solid var(--glass-border);
  margin: 0.75rem 0;
}

.skill-split-col {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.skill-split-label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-muted);
}

.skill-split-divider {
  font-size: 1.2rem;
  text-align: center;
  opacity: 0.7;
}

.ev-activity-select-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.85rem 1.15rem;
  border-radius: 12px;
  border: 1px solid var(--glass-border);
  background: var(--glass-bg);
  cursor: pointer;
  transition: all 0.2s;
}

.ev-activity-select-card:hover {
  border-color: var(--ev-primary);
}

.ev-activity-select-card.selected {
  border-color: var(--ev-primary);
  background: var(--ev-primary-muted);
}

[data-theme='light'] .ev-activity-select-card {
  background: #ffffff;
  border-color: #e2e8f0;
}

[data-theme='light'] .ev-activity-select-card.selected {
  border-color: #0f172a;
  background: #f8fafc;
}

.ev-activity-select-card .ev-checkbox {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 1.5px solid var(--glass-border);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
  background: var(--glass-bg);
}

.ev-activity-select-card.selected .ev-checkbox {
  background: var(--ev-primary);
  border-color: var(--ev-primary);
  color: white;
}

[data-theme='light'] .ev-activity-select-card.selected .ev-checkbox {
  background: #0f172a;
  border-color: #0f172a;
}

/* ==========================================================================
   FEED & RECOMMENDATIONS
   ========================================================================== */

.ev-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.ev-section-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-main);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  letter-spacing: -0.01em;
}

.ev-section-count {
  font-size: 0.78rem;
  color: var(--text-muted);
  background: var(--glass-bg);
  padding: 0.2rem 0.6rem;
  border-radius: 8px;
  border: 1px solid var(--glass-border);
}

[data-theme='light'] .ev-section-count {
  background: #f1f5f9;
  border-color: #e2e8f0;
}

.ev-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
}

@media (max-width: 640px) {
  .ev-cards-grid {
    grid-template-columns: 1fr;
  }
}

.match-reasons {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-top: 0.75rem;
}

.match-reason {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.78rem;
  color: var(--text-secondary);
}

.match-reason .reason-icon {
  color: var(--ev-green);
  flex-shrink: 0;
}

.completion-ring-wrapper {
  position: relative;
  width: 72px;
  height: 72px;
  flex-shrink: 0;
}

.completion-ring-wrapper svg {
  transform: rotate(-90deg);
}

.completion-ring-bg {
  fill: none;
  stroke: var(--glass-border);
  stroke-width: 5;
}

.completion-ring-fill {
  fill: none;
  stroke: var(--ev-primary);
  stroke-width: 5;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.8s ease;
}

.completion-ring-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--text-main);
  text-align: center;
}

/* Search bar */
.ev-search-wrapper {
  position: relative;
}

.ev-search-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  pointer-events: none;
}

.ev-search-input {
  width: 100%;
  padding: 0.8rem 1rem 0.8rem 2.6rem;
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: 12px;
  color: var(--input-text);
  font-size: 0.92rem;
  transition: all 0.2s;
  box-sizing: border-box;
}

.ev-search-input:focus {
  outline: none;
  border-color: var(--ev-primary);
  box-shadow: 0 0 0 2px var(--ev-primary-muted);
}

.ev-search-input::placeholder {
  color: var(--input-placeholder);
}

/* Stats */
.ev-stats-bar {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
}

.ev-stat-card {
  background: var(--glass-bg);
  border: 1px solid var(--glass-border);
  border-radius: 14px;
  padding: 0.9rem;
  text-align: center;
}

.ev-stat-number {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--text-main);
}

.ev-stat-label {
  font-size: 0.72rem;
  color: var(--text-muted);
  font-weight: 500;
  margin-top: 0.15rem;
}

[data-theme='light'] .ev-stat-card {
  background: #ffffff;
  border-color: #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

/* Toast */
.ev-toast {
  position: fixed;
  top: 1.5rem;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  z-index: 1200;
  max-width: 440px;
  width: calc(100% - 2rem);
  padding: 0.85rem 1.15rem;
  border-radius: 12px;
  background: #0f172a;
  color: white;
  font-weight: 500;
  font-size: 0.88rem;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
}

/* Avatars */
.ev-avatar {
  border-radius: 50%;
  object-fit: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
  overflow: hidden;
}

.ev-avatar-lg {
  width: 56px;
  height: 56px;
  font-size: 1.25rem;
}

.ev-avatar-sm {
  width: 38px;
  height: 38px;
  font-size: 0.85rem;
}

.ev-avatar-gradient-0 { background: #3b82f6; }
.ev-avatar-gradient-1 { background: #6366f1; }
.ev-avatar-gradient-2 { background: #0d9488; }
.ev-avatar-gradient-3 { background: #d97706; }
.ev-avatar-gradient-4 { background: #475569; }

/* Mobile navigation */
.events-mobile-nav {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: var(--dropdown-bg);
  backdrop-filter: blur(20px);
  border-top: 1px solid var(--glass-border);
  z-index: 100;
  padding: 0 1rem;
  align-items: center;
  justify-content: space-around;
}

@media (max-width: 768px) {
  .events-mobile-nav {
    display: flex;
  }
  .events-wrapper {
    padding: 1rem;
    padding-bottom: 5rem;
  }
  .ev-cards-grid {
    grid-template-columns: 1fr;
  }
  .ev-form-row {
    grid-template-columns: 1fr;
  }
  .ev-stats-bar {
    grid-template-columns: repeat(3, 1fr);
  }
  .ev-modal {
    max-height: 95vh;
  }
  .ev-modal-body {
    padding: 1rem 1.25rem;
  }
  .ev-modal-header {
    padding: 1.15rem 1.25rem 0.75rem;
  }
  .ev-modal-footer {
    padding: 0.75rem 1.25rem 1.15rem;
  }
  .skill-split {
    grid-template-columns: 1fr;
  }
  .skill-split-divider {
    display: none;
  }
}

.mobile-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  color: var(--text-muted);
  font-size: 0.65rem;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.2s;
  padding: 0.5rem;
  background: none;
  border: none;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.mobile-nav-item.active {
  color: var(--ev-primary);
}

.mobile-nav-item svg {
  width: 20px;
  height: 20px;
}

/* ==========================================================================
   CONVERGENCE EXTERNAL PARTICIPANT & CTA STYLING (High-Contrast Light & Dark)
   ========================================================================== */

.ev-btn-external {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.95rem 1.35rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
  color: #ffffff !important;
  border: 1px solid #7c3aed;
  box-shadow: 0 4px 18px rgba(124, 58, 237, 0.35);
}

.ev-btn-external:hover {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(124, 58, 237, 0.5);
  color: #ffffff !important;
}

.ev-btn-external:active {
  transform: translateY(0);
}

.ev-divider-or {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  margin: 0.25rem 0.5rem;
}

.ev-divider-or-line {
  flex: 1 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.18);
}

[data-theme='light'] .ev-divider-or-line {
  background: #cbd5e1;
}

.ev-divider-or-text {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  color: var(--text-secondary, #94a3b8);
  background: var(--glass-bg, rgba(255, 255, 255, 0.06));
  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.15));
}

[data-theme='light'] .ev-divider-or-text {
  color: #334155;
  background: #f1f5f9;
  border-color: #cbd5e1;
}

/* External Attendee Badges */
.ev-badge-external {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.74rem;
  font-weight: 700;
  padding: 0.2rem 0.65rem;
  border-radius: 8px;
  background: #7c3aed;
  color: #ffffff !important;
  box-shadow: 0 2px 8px rgba(124, 58, 237, 0.3);
  letter-spacing: 0.02em;
  white-space: nowrap;
}

[data-theme='light'] .ev-badge-external {
  background: #7c3aed;
  color: #ffffff !important;
}

.ev-badge-internal {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.74rem;
  font-weight: 700;
  padding: 0.2rem 0.65rem;
  border-radius: 8px;
  background: rgba(37, 99, 235, 0.15);
  color: #3b82f6;
  border: 1px solid rgba(37, 99, 235, 0.3);
  letter-spacing: 0.02em;
  white-space: nowrap;
}

[data-theme='light'] .ev-badge-internal {
  background: #eff6ff;
  color: #1d4ed8;
  border-color: #bfdbfe;
}

/* ==========================================================================
   FLOATING ACTION & SCROLL GUIDANCE (Landing Page)
   ========================================================================== */
.ev-floating-scroll-guide {
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 90;
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.75rem 1.4rem;
  background: rgba(15, 23, 42, 0.92);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 9999px;
  color: #ffffff;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.08);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  animation: ev-pulse-subtle 2.5s infinite;
}

.ev-floating-scroll-guide:hover {
  transform: translateX(-50%) translateY(-3px);
  background: #1e293b;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.6), 0 0 20px rgba(37, 99, 235, 0.3);
  border-color: rgba(59, 130, 246, 0.5);
}

@keyframes ev-pulse-subtle {
  0%, 100% {
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5);
  }
  50% {
    box-shadow: 0 14px 36px rgba(37, 99, 235, 0.25), 0 0 0 4px rgba(37, 99, 235, 0.12);
  }
}

/* ==========================================================================
   IMMERSIVE PROFILE PREVIEW DRAWER (Desktop slide-right / Mobile sheet)
   ========================================================================== */
.ev-drawer-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(4, 7, 14, 0.72);
  backdrop-filter: blur(6px);
  z-index: 1100;
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
}

.ev-drawer {
  width: 100%;
  max-width: 580px;
  height: 100%;
  background: #0b0f19;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: -16px 0 48px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  z-index: 1101;
}

[data-theme='light'] .ev-drawer {
  background: #ffffff;
  border-left-color: #e2e8f0;
  box-shadow: -12px 0 36px rgba(0, 0, 0, 0.1);
}

.ev-drawer-header {
  padding: 1.25rem 1.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(12px);
  flex-shrink: 0;
}

[data-theme='light'] .ev-drawer-header {
  border-bottom-color: #f1f5f9;
  background: #f8fafc;
}

.ev-drawer-nav-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ev-drawer-nav-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: var(--text-main);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.ev-drawer-nav-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.2);
}

.ev-drawer-nav-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.ev-drawer-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.15) transparent;
}

.ev-drawer-hero {
  display: flex;
  gap: 1.25rem;
  align-items: flex-start;
}

.ev-drawer-avatar {
  width: 76px;
  height: 76px;
  border-radius: 20px;
  object-fit: cover;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  font-weight: 800;
  color: #ffffff;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border: 2px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.ev-drawer-title-group {
  flex: 1 1;
  min-width: 0;
}

.ev-drawer-name {
  font-size: 1.4rem;
  font-weight: 800;
  color: var(--text-main);
  margin: 0;
  line-height: 1.2;
}

.ev-drawer-sub {
  font-size: 0.88rem;
  color: var(--text-secondary);
  margin-top: 0.35rem;
}

.ev-drawer-section {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.ev-drawer-section-title {
  font-size: 0.76rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-muted);
}

.ev-chip-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.ev-skill-pill {
  padding: 0.35rem 0.75rem;
  border-radius: 8px;
  font-size: 0.82rem;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: var(--text-main);
}

.ev-skill-pill.highlight {
  background: rgba(37, 99, 235, 0.15);
  border-color: rgba(37, 99, 235, 0.35);
  color: #93c5fd;
  font-weight: 600;
}

.ev-drawer-footer {
  padding: 1.25rem 1.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(12px);
  display: flex;
  gap: 0.75rem;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .ev-drawer-backdrop {
    align-items: flex-end;
  }
  .ev-drawer {
    max-width: 100%;
    height: 90vh;
    border-radius: 24px 24px 0 0;
    border-left: none;
    border-top: 1px solid rgba(255, 255, 255, 0.15);
  }
}

/* ==========================================================================
   NETWORKING STATS METRIC CARDS
   ========================================================================== */
.ev-stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.15rem;
  margin-bottom: 2rem;
}

@media (max-width: 1024px) {
  .ev-stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
}

@media (max-width: 640px) {
  .ev-stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    margin-bottom: 1.5rem;
  }

  .ev-stat-card {
    aspect-ratio: 1 / 1;
    padding: 0.95rem;
    border-radius: 16px;
    justify-content: space-between;
    gap: 0.35rem;
  }

  .ev-stat-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
    width: 100%;
  }

  .ev-stat-label {
    font-size: 0.78rem;
    font-weight: 700;
    line-height: 1.2;
  }

  .ev-stat-badge {
    font-size: 0.6rem;
    padding: 0.12rem 0.4rem;
  }

  .ev-stat-number-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
    width: 100%;
  }

  .ev-stat-number {
    font-size: 1.95rem;
    font-weight: 900;
  }

  .ev-stat-mini-progress {
    width: 100%;
    height: 4px;
  }

  .ev-stat-footer {
    display: none;
  }
}

.ev-stat-card {
  background: var(--glass-bg);
  border: 1px solid var(--glass-border);
  border-radius: 18px;
  padding: 1.2rem 1.35rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.85rem;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  overflow: hidden;
}

.ev-stat-card:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 255, 255, 0.22);
  box-shadow: 0 12px 24px -6px rgba(0, 0, 0, 0.35);
}

[data-theme='light'] .ev-stat-card {
  background: #ffffff;
  border-color: #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

[data-theme='light'] .ev-stat-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 10px 20px -4px rgba(0, 0, 0, 0.08);
}

.ev-stat-card.active-stat {
  border-color: var(--ev-primary);
  background: rgba(37, 99, 235, 0.08);
}

.ev-stat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
}

.ev-stat-label {
  font-size: 0.84rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: capitalize;
  letter-spacing: -0.01em;
}

.ev-stat-badge {
  font-size: 0.68rem;
  font-weight: 700;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.ev-stat-badge-blue {
  background: rgba(37, 99, 235, 0.14);
  color: #60a5fa;
  border: 1px solid rgba(37, 99, 235, 0.28);
}

.ev-stat-badge-green {
  background: rgba(34, 197, 94, 0.14);
  color: #4ade80;
  border: 1px solid rgba(34, 197, 94, 0.28);
}

.ev-stat-badge-amber {
  background: rgba(245, 158, 11, 0.14);
  color: #fbbf24;
  border: 1px solid rgba(245, 158, 11, 0.28);
}

.ev-stat-badge-purple {
  background: rgba(168, 85, 247, 0.14);
  color: #c084fc;
  border: 1px solid rgba(168, 85, 247, 0.28);
}

.ev-stat-badge-cyan {
  background: rgba(6, 182, 212, 0.14);
  color: #22d3ee;
  border: 1px solid rgba(6, 182, 212, 0.28);
}

.ev-stat-number-row {
  display: flex;
  align-items: baseline;
  gap: 0.85rem;
}

.ev-stat-number {
  font-size: 2.25rem;
  font-weight: 900;
  letter-spacing: -0.04em;
  color: var(--text-main);
  line-height: 1;
}

.ev-stat-mini-progress {
  flex: 1 1;
  height: 6px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  overflow: hidden;
  align-self: center;
}

[data-theme='light'] .ev-stat-mini-progress {
  background: #e2e8f0;
}

.ev-stat-mini-fill {
  height: 100%;
  background: linear-gradient(90deg, #2563eb, #38bdf8);
  border-radius: 999px;
  transition: width 0.4s ease;
}

.ev-stat-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.78rem;
  color: var(--text-muted);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding-top: 0.65rem;
}

[data-theme='light'] .ev-stat-footer {
  border-top-color: #f1f5f9;
}

.ev-stat-action {
  color: var(--ev-primary);
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

/* ==========================================================================
   FEATURED RECOMMENDATION HERO STORY
   ========================================================================== */
.ev-featured-rec {
  background: linear-gradient(135deg, rgba(30, 41, 59, 0.6) 0%, rgba(15, 23, 42, 0.8) 100%);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  padding: 1.75rem;
  margin-bottom: 2.25rem;
  position: relative;
  overflow: hidden;
  box-shadow: 0 16px 36px -10px rgba(0, 0, 0, 0.45);
  transition: border-color 0.25s;
}

.ev-featured-rec:hover {
  border-color: rgba(59, 130, 246, 0.4);
}

[data-theme='light'] .ev-featured-rec {
  background: #ffffff;
  border-color: #e2e8f0;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.ev-featured-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.74rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #60a5fa;
  margin-bottom: 1rem;
}

.ev-featured-layout {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 1.5rem;
  align-items: center;
}

@media (max-width: 768px) {
  .ev-featured-layout {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

/* ==========================================================================
   REFINED PERSON DISCOVERY CARDS (Original Editorial Look)
   ========================================================================== */
.ev-person-card {
  background: var(--glass-bg);
  border: 1px solid var(--glass-border);
  border-radius: 18px;
  padding: 1.35rem 1.4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.15rem;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
}

.ev-person-card:hover {
  transform: translateY(-3px);
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 14px 28px -6px rgba(0, 0, 0, 0.45);
}

[data-theme='light'] .ev-person-card {
  background: #ffffff;
  border-color: #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

[data-theme='light'] .ev-person-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 12px 24px -4px rgba(0, 0, 0, 0.08);
}

.ev-person-top {
  display: flex;
  gap: 0.9rem;
  align-items: flex-start;
}

.ev-person-name {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-main);
  line-height: 1.25;
  margin: 0;
}

.ev-person-meta {
  font-size: 0.8rem;
  color: var(--text-secondary);
  margin-top: 0.25rem;
}

.ev-why-match-box {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  padding: 0.65rem 0.85rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

[data-theme='light'] .ev-why-match-box {
  background: #f8fafc;
  border-color: #f1f5f9;
}

.ev-why-match-item {
  font-size: 0.78rem;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.ev-compat-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
  background: rgba(37, 99, 235, 0.12);
  color: #60a5fa;
  border: 1px solid rgba(37, 99, 235, 0.25);
}

/* ==========================================================================
   7-STEP ONBOARDING JOURNEY
   ========================================================================== */
.ev-onboard-wrapper {
  max-width: 680px;
  width: 100%;
  margin: 0 auto;
}

.ev-onboard-header {
  margin-bottom: 1.5rem;
}

.ev-onboard-progress-bar {
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 2px;
  overflow: hidden;
  margin-top: 1rem;
}

.ev-onboard-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #2563eb, #7c3aed);
  transition: width 0.35s ease;
}

.ev-interest-cluster-title {
  font-size: 0.74rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-muted);
  margin: 1.25rem 0 0.5rem;
}

.ev-interest-cluster-title:first-child {
  margin-top: 0;
}

.ev-interest-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.ev-selectable-card {
  padding: 0.5rem 0.95rem;
  border-radius: 10px;
  border: 1px solid var(--glass-border);
  background: var(--glass-bg);
  color: var(--text-secondary);
  font-size: 0.84rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.ev-selectable-card:hover {
  border-color: rgba(255, 255, 255, 0.25);
  color: var(--text-main);
  transform: translateY(-1px);
}

.ev-selectable-card.selected {
  background: rgba(37, 99, 235, 0.16);
  border-color: #3b82f6;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 0 14px rgba(37, 99, 235, 0.25);
}

[data-theme='light'] .ev-selectable-card.selected {
  background: #eff6ff;
  border-color: #2563eb;
  color: #1e40af;
}

.ev-onboard-review-box {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.15rem;
}

.ev-review-row {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.ev-review-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-muted);
}

.ev-review-value {
  font-size: 0.92rem;
  color: var(--text-main);
  font-weight: 500;
}


`, "",{"version":3,"sources":["webpack://./src/pages/events/Events.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAGxB;;+EAE+E;;AAE/E;EACE,oDAAoD;EACpD,qBAAqB;EACrB,2BAA2B;EAC3B,2CAA2C;EAC3C,oBAAoB;EACpB,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;;EAEjB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,6BAA6B;;EAE7B,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;EAC1C,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,qEAAqE;EACrE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;+EAE+E;;AAE/E;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,6EAA6E;EAC7E,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;;+EAE+E;;AAE/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;+EAE+E;;AAE/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;+EAE+E;;AAE/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;+EAE+E;;AAE/E;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,6DAA6D;EAC7D,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,0GAA0G;AAC5G;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,2BAA2B;EAC3B,kCAAkC;EAClC,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;+EAE+E;;AAE/E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,yDAAsN;EACtN,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mCAAmC;EACnC,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,SAAO;EACP,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;AACjC;;AAEA,UAAU;AACV;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,UAAU;AACV;EACE,eAAe;EACf,WAAW;EACX,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,mBAAmB,EAAE;;AAE7C,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,8BAA8B;EAC9B,2BAA2B;EAC3B,yCAAyC;EACzC,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,qCAAqC;EACvC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;+EAE+E;;AAE/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kDAAkD;EAClD,6DAA6D;EAC7D,yBAAyB;EACzB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,qCAAqC;EACrC,sDAAsD;EACtD,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,wCAAwC;EACxC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;EAC3B,2CAA2C;EAC3C,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,+EAA+E;EAC/E,kDAAkD;EAClD,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,2EAA2E;EAC3E,qCAAqC;AACvC;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,kFAAkF;EACpF;AACF;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,iCAAiC;EACjC,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,YAAY;IACZ,4BAA4B;IAC5B,iBAAiB;IACjB,+CAA+C;EACjD;AACF;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,mDAAmD;EACnD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;+EAE+E;AAC/E;EACE,yFAAyF;EACzF,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;EACjD,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;;+EAE+E;AAC/E;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;;+EAE+E;AAC/E;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":["/* Import Google Fonts */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');\n\n/* ==========================================================================\n   EVENTS DESIGN SYSTEM - Official, Minimalist & Theme-Aware\n   ========================================================================== */\n\n:root {\n  /* Minimalist Official Palette - Dark Mode Default */\n  --ev-primary: #2563eb;\n  --ev-primary-hover: #1d4ed8;\n  --ev-primary-muted: rgba(37, 99, 235, 0.12);\n  --ev-purple: #4f46e5;\n  --ev-purple-glow: rgba(79, 70, 229, 0.15);\n  --ev-blue: #2563eb;\n  --ev-teal: #0d9488;\n  --ev-orange: #d97706;\n  --ev-green: #059669;\n  --ev-red: #dc2626;\n  \n  /* Domain colors */\n  --domain-aiml: #4f46e5;\n  --domain-web: #2563eb;\n  --domain-design: #0d9488;\n  --domain-security: #059669;\n  --domain-programming: #d97706;\n  \n  /* Category backgrounds */\n  --cat-hackathon: #4f46e5;\n  --cat-ctf: #059669;\n  --cat-workshop: #2563eb;\n  --cat-contest: #d97706;\n  --cat-paper: #64748b;\n}\n\n[data-theme='light'] {\n  --ev-primary: #0f172a;\n  --ev-primary-hover: #1e293b;\n  --ev-primary-muted: rgba(15, 23, 42, 0.06);\n  --ev-purple: #3b82f6;\n  --ev-purple-glow: rgba(59, 130, 246, 0.12);\n}\n\n.events-page {\n  min-height: 100vh;\n  background: #f7f7f4 !important;\n  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;\n  color: #171a24 !important;\n}\n\n.events-wrapper {\n  max-width: 1160px;\n  margin: 0 auto;\n  padding: 1.5rem;\n}\n\n/* ==========================================================================\n   CARDS & CONTAINERS\n   ========================================================================== */\n\n.match-card {\n  background: var(--glass-bg);\n  backdrop-filter: blur(12px);\n  border: 1px solid var(--glass-border);\n  border-radius: 16px;\n  padding: 1.25rem 1.5rem;\n  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n\n.match-card:hover {\n  transform: translateY(-2px);\n  border-color: rgba(255, 255, 255, 0.18);\n  box-shadow: 0 12px 24px -6px rgba(0, 0, 0, 0.35);\n}\n\n[data-theme='light'] .match-card {\n  background: #ffffff;\n  border-color: #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n[data-theme='light'] .match-card:hover {\n  border-color: #cbd5e1;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.08);\n}\n\n/* ==========================================================================\n   PILLS & BADGES\n   ========================================================================== */\n\n.match-score-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.25rem 0.65rem;\n  border-radius: 10px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  background: rgba(37, 99, 235, 0.12);\n  border: 1px solid rgba(37, 99, 235, 0.25);\n  color: #93c5fd;\n}\n\n[data-theme='light'] .match-score-pill {\n  color: #1d4ed8;\n  background: #eff6ff;\n  border-color: #bfdbfe;\n}\n\n.alumni-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.2rem 0.6rem;\n  border-radius: 8px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  background: rgba(217, 119, 6, 0.12);\n  border: 1px solid rgba(217, 119, 6, 0.25);\n  color: #fbbf24;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n[data-theme='light'] .alumni-badge {\n  background: #fffbeb;\n  border-color: #fde68a;\n  color: #b45309;\n}\n\n.activity-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.2rem 0.6rem;\n  border-radius: 8px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  border: 1px solid transparent;\n}\n\n.activity-badge.hackathon {\n  background: rgba(99, 102, 241, 0.12);\n  border-color: rgba(99, 102, 241, 0.25);\n  color: #c7d2fe;\n}\n.activity-badge.ctf {\n  background: rgba(16, 185, 129, 0.12);\n  border-color: rgba(16, 185, 129, 0.25);\n  color: #a7f3d0;\n}\n.activity-badge.workshop {\n  background: rgba(59, 130, 246, 0.12);\n  border-color: rgba(59, 130, 246, 0.25);\n  color: #bfdbfe;\n}\n.activity-badge.contest {\n  background: rgba(245, 158, 11, 0.12);\n  border-color: rgba(245, 158, 11, 0.25);\n  color: #fde68a;\n}\n.activity-badge.paper {\n  background: rgba(148, 163, 184, 0.12);\n  border-color: rgba(148, 163, 184, 0.25);\n  color: #cbd5e1;\n}\n\n[data-theme='light'] .activity-badge.hackathon {\n  background: #eef2ff;\n  border-color: #c7d2fe;\n  color: #4338ca;\n}\n[data-theme='light'] .activity-badge.ctf {\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n  color: #065f46;\n}\n[data-theme='light'] .activity-badge.workshop {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #1e40af;\n}\n[data-theme='light'] .activity-badge.contest {\n  background: #fffbeb;\n  border-color: #fde68a;\n  color: #b45309;\n}\n[data-theme='light'] .activity-badge.paper {\n  background: #f8fafc;\n  border-color: #e2e8f0;\n  color: #475569;\n}\n\n/* ==========================================================================\n   BUTTONS\n   ========================================================================== */\n\n.ev-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.6rem;\n  border-radius: 12px;\n  border: 1px solid transparent;\n  background: var(--ev-primary);\n  color: #ffffff;\n  font-size: 0.92rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n}\n\n.ev-btn-primary:hover {\n  background: var(--ev-primary-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n[data-theme='light'] .ev-btn-primary {\n  background: #0f172a;\n  color: #ffffff;\n}\n\n[data-theme='light'] .ev-btn-primary:hover {\n  background: #1e293b;\n}\n\n.ev-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.7rem 1.4rem;\n  border-radius: 12px;\n  border: 1px solid var(--glass-border);\n  background: var(--glass-bg);\n  color: var(--text-main);\n  font-size: 0.88rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.ev-btn-secondary:hover {\n  background: var(--glass-hover);\n  transform: translateY(-1px);\n}\n\n[data-theme='light'] .ev-btn-secondary {\n  background: #ffffff;\n  border-color: #e2e8f0;\n  color: #1e293b;\n}\n\n.ev-connect-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.5rem 1.1rem;\n  border-radius: 10px;\n  font-size: 0.84rem;\n  font-weight: 600;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: var(--ev-primary);\n  color: white;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n}\n\n.ev-connect-btn:hover {\n  background: var(--ev-primary-hover);\n  transform: translateY(-1px);\n}\n\n[data-theme='light'] .ev-connect-btn {\n  background: #0f172a;\n  color: #ffffff;\n}\n\n[data-theme='light'] .ev-connect-btn:hover {\n  background: #1e293b;\n}\n\n.ev-connect-btn.pending {\n  background: rgba(255, 255, 255, 0.06);\n  color: var(--text-secondary);\n  border: 1px solid var(--glass-border);\n  box-shadow: none;\n  cursor: default;\n}\n\n.ev-connect-btn.connected {\n  background: rgba(16, 185, 129, 0.12);\n  color: #10b981;\n  border: 1px solid rgba(16, 185, 129, 0.25);\n  box-shadow: none;\n  cursor: default;\n}\n\n[data-theme='light'] .ev-connect-btn.connected {\n  background: #ecfdf5;\n  color: #065f46;\n  border-color: #a7f3d0;\n}\n\n.ev-connect-btn.pending:hover,\n.ev-connect-btn.connected:hover {\n  transform: none;\n}\n\n/* ==========================================================================\n   STATUS BADGES\n   ========================================================================== */\n\n.ev-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.25rem 0.75rem;\n  border-radius: 8px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.ev-status-badge.live {\n  background: rgba(16, 185, 129, 0.12);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n  color: #34d399;\n}\n\n.ev-status-badge.live::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #10b981;\n}\n\n.ev-status-badge.upcoming {\n  background: rgba(59, 130, 246, 0.12);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  color: #93c5fd;\n}\n\n.ev-status-badge.completed {\n  background: rgba(148, 163, 184, 0.12);\n  border: 1px solid rgba(148, 163, 184, 0.3);\n  color: #cbd5e1;\n}\n\n[data-theme='light'] .ev-status-badge.live {\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n  color: #065f46;\n}\n\n[data-theme='light'] .ev-status-badge.upcoming {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #1e40af;\n}\n\n[data-theme='light'] .ev-status-badge.completed {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n  color: #475569;\n}\n\n/* ==========================================================================\n   HERO & LANDING PAGE COMPONENTS\n   ========================================================================== */\n\n.ev-hero {\n  position: relative;\n  border-radius: 20px;\n  overflow: hidden;\n  min-height: 270px;\n  display: flex;\n  align-items: flex-end;\n  padding: 2.25rem;\n  background: linear-gradient(135deg, #090d16 0%, #111827 100%);\n  border: 1px solid var(--glass-border);\n}\n\n[data-theme='light'] .ev-hero {\n  border-color: #e2e8f0;\n}\n\n.ev-hero-img {\n  position: absolute;\n  inset: 0;\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n  opacity: 0.35;\n}\n\n.ev-hero-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to top, rgba(9, 13, 22, 0.94) 0%, rgba(9, 13, 22, 0.45) 60%, transparent 100%);\n}\n\n.ev-hero-content {\n  position: relative;\n  z-index: 2;\n}\n\n.ev-hero-title {\n  font-size: clamp(1.8rem, 3.5vw, 2.75rem);\n  font-weight: 800;\n  color: #ffffff;\n  line-height: 1.15;\n  margin-bottom: 0.5rem;\n  letter-spacing: -0.02em;\n}\n\n.ev-hero-sub {\n  font-size: 0.95rem;\n  color: rgba(255, 255, 255, 0.82);\n  margin-bottom: 0.5rem;\n  max-width: 820px;\n  line-height: 1.5;\n}\n\n/* Minimalist metadata strip */\n.ev-meta-bar {\n  display: flex;\n  gap: 2rem;\n  padding: 1.15rem 1.5rem;\n  background: var(--glass-bg);\n  border-radius: 14px;\n  margin: 1.75rem 0;\n  border: 1px solid var(--glass-border);\n  flex-wrap: wrap;\n}\n\n[data-theme='light'] .ev-meta-bar {\n  background: #ffffff;\n  border-color: #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.ev-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-size: 0.92rem;\n  font-weight: 500;\n  color: var(--text-main);\n}\n\n.ev-meta-icon {\n  color: var(--text-secondary);\n  flex-shrink: 0;\n}\n\n/* Minimalist Join Networking CTA Card */\n.ev-cta-card {\n  text-align: center;\n  padding: 3rem 1.5rem;\n  background: var(--glass-bg);\n  border-radius: 20px;\n  border: 1px solid var(--glass-border);\n  margin-top: 1rem;\n}\n\n[data-theme='light'] .ev-cta-card {\n  background: #ffffff;\n  border-color: #e2e8f0;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);\n}\n\n.ev-cta-card h2 {\n  font-size: 1.55rem;\n  font-weight: 700;\n  margin-bottom: 0.6rem;\n  color: var(--text-main);\n  letter-spacing: -0.01em;\n}\n\n.ev-cta-card p {\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n  max-width: 580px;\n  margin: 0 auto 1.75rem;\n  line-height: 1.5;\n}\n\n/* ==========================================================================\n   NAVIGATION & TABS\n   ========================================================================== */\n\n.category-anchors {\n  display: flex;\n  gap: 0.5rem;\n  overflow-x: auto;\n  padding: 0.75rem 1.5rem;\n  scrollbar-width: none;\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  backdrop-filter: blur(20px);\n  background: rgba(15, 15, 30, 0.85);\n  border-bottom: 1px solid var(--glass-border);\n  margin: 0 -1.5rem;\n}\n\n.category-anchors::-webkit-scrollbar {\n  display: none;\n}\n\n[data-theme='light'] .category-anchors {\n  background: rgba(255, 255, 255, 0.9);\n  border-bottom-color: #e2e8f0;\n}\n\n.anchor-pill {\n  flex-shrink: 0;\n  padding: 0.4rem 1rem;\n  border-radius: 10px;\n  border: 1px solid var(--glass-border);\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n}\n\n.anchor-pill:hover {\n  background: var(--glass-hover);\n  color: var(--text-main);\n}\n\n.anchor-pill.active {\n  background: var(--ev-primary);\n  border-color: var(--ev-primary);\n  color: white;\n}\n\n[data-theme='light'] .anchor-pill.active {\n  background: #0f172a;\n  border-color: #0f172a;\n}\n\n.ev-tab-nav {\n  display: flex;\n  gap: 0;\n  border-radius: 10px;\n  background: var(--glass-bg);\n  padding: 0.25rem;\n  border: 1px solid var(--glass-border);\n}\n\n[data-theme='light'] .ev-tab-nav {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n}\n\n.ev-tab-btn {\n  flex: 1;\n  padding: 0.5rem 0.75rem;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 0.82rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.ev-tab-btn.active {\n  background: var(--ev-primary);\n  color: white;\n}\n\n[data-theme='light'] .ev-tab-btn.active {\n  background: #0f172a;\n  color: white;\n}\n\n/* ==========================================================================\n   MODAL & FORMS\n   ========================================================================== */\n\n.ev-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n.ev-modal {\n  width: 100%;\n  max-width: 640px;\n  max-height: 90vh;\n  margin: auto;\n  background: #0f172a;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.6);\n  position: relative;\n}\n\n[data-theme='light'] .ev-modal {\n  background: #ffffff;\n  border-color: #e2e8f0;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);\n}\n\n.ev-modal-header {\n  padding: 1.25rem 1.75rem;\n  background: transparent;\n  border-bottom: 1px solid var(--glass-border);\n  flex-shrink: 0;\n}\n\n[data-theme='light'] .ev-modal-header {\n  border-bottom-color: #e2e8f0;\n}\n\n.ev-modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.5rem 1.75rem;\n  scrollbar-width: thin;\n  scrollbar-color: var(--glass-border) transparent;\n}\n\n.ev-modal-footer {\n  padding: 1rem 1.75rem 1.25rem;\n  border-top: 1px solid var(--glass-border);\n  flex-shrink: 0;\n}\n\n[data-theme='light'] .ev-modal-footer {\n  border-top-color: #e2e8f0;\n}\n\n.ev-input {\n  width: 100%;\n  padding: 0.7rem 0.9rem;\n  background: var(--input-bg);\n  border: 1px solid var(--input-border);\n  border-radius: 10px;\n  color: var(--input-text);\n  font-size: 0.9rem;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.ev-input:focus {\n  outline: none;\n  border-color: var(--ev-primary);\n  box-shadow: 0 0 0 2px var(--ev-primary-muted);\n}\n\n.ev-input::placeholder {\n  color: var(--input-placeholder);\n}\n\n.ev-select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23999' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  padding-right: 2.5rem;\n}\n\n.ev-label {\n  display: block;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-bottom: 0.4rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.ev-form-group {\n  margin-bottom: 1.15rem;\n}\n\n.ev-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n@media (max-width: 480px) {\n  .ev-form-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ev-pill-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n}\n\n.ev-pill {\n  padding: 0.35rem 0.8rem;\n  border-radius: 8px;\n  border: 1px solid var(--glass-border);\n  background: var(--glass-bg);\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.ev-pill:hover {\n  border-color: var(--ev-primary);\n  color: var(--text-main);\n}\n\n.ev-pill.selected {\n  background: var(--ev-primary-muted);\n  border-color: var(--ev-primary);\n  color: var(--text-main);\n  font-weight: 600;\n}\n\n[data-theme='light'] .ev-pill {\n  background: #ffffff;\n  border-color: #e2e8f0;\n}\n\n[data-theme='light'] .ev-pill.selected {\n  background: #eff6ff;\n  border-color: #93c5fd;\n  color: #1e40af;\n}\n\n.ev-progress-steps {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.ev-step-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--glass-border);\n  transition: all 0.3s;\n}\n\n.ev-step-dot.active {\n  background: var(--ev-primary);\n  width: 20px;\n  border-radius: 4px;\n}\n\n.ev-step-dot.done {\n  background: var(--ev-primary);\n}\n\n.ev-tag-input-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  padding: 0.5rem;\n  background: var(--input-bg);\n  border: 1px solid var(--input-border);\n  border-radius: 10px;\n  min-height: 44px;\n  cursor: text;\n  transition: border-color 0.2s;\n}\n\n.ev-tag-input-wrapper:focus-within {\n  border-color: var(--ev-primary);\n  box-shadow: 0 0 0 2px var(--ev-primary-muted);\n}\n\n.ev-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.2rem 0.55rem;\n  background: var(--ev-primary-muted);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 6px;\n  color: var(--text-main);\n  font-size: 0.78rem;\n  font-weight: 500;\n}\n\n[data-theme='light'] .ev-tag {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #1e40af;\n}\n\n.ev-tag button {\n  background: none;\n  border: none;\n  color: inherit;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  opacity: 0.7;\n}\n\n.ev-tag button:hover {\n  opacity: 1;\n}\n\n.ev-tag-input {\n  border: none;\n  background: transparent;\n  color: var(--input-text);\n  font-size: 0.85rem;\n  outline: none;\n  flex: 1;\n  min-width: 80px;\n  padding: 0.1rem 0.3rem;\n}\n\n.ev-tag-input::placeholder {\n  color: var(--input-placeholder);\n}\n\n.skill-split {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 0.5rem;\n  align-items: center;\n  background: var(--glass-bg);\n  border-radius: 10px;\n  padding: 0.75rem;\n  border: 1px solid var(--glass-border);\n  margin: 0.75rem 0;\n}\n\n.skill-split-col {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.skill-split-label {\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-muted);\n}\n\n.skill-split-divider {\n  font-size: 1.2rem;\n  text-align: center;\n  opacity: 0.7;\n}\n\n.ev-activity-select-card {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.85rem 1.15rem;\n  border-radius: 12px;\n  border: 1px solid var(--glass-border);\n  background: var(--glass-bg);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.ev-activity-select-card:hover {\n  border-color: var(--ev-primary);\n}\n\n.ev-activity-select-card.selected {\n  border-color: var(--ev-primary);\n  background: var(--ev-primary-muted);\n}\n\n[data-theme='light'] .ev-activity-select-card {\n  background: #ffffff;\n  border-color: #e2e8f0;\n}\n\n[data-theme='light'] .ev-activity-select-card.selected {\n  border-color: #0f172a;\n  background: #f8fafc;\n}\n\n.ev-activity-select-card .ev-checkbox {\n  width: 20px;\n  height: 20px;\n  border-radius: 6px;\n  border: 1.5px solid var(--glass-border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  flex-shrink: 0;\n  background: var(--glass-bg);\n}\n\n.ev-activity-select-card.selected .ev-checkbox {\n  background: var(--ev-primary);\n  border-color: var(--ev-primary);\n  color: white;\n}\n\n[data-theme='light'] .ev-activity-select-card.selected .ev-checkbox {\n  background: #0f172a;\n  border-color: #0f172a;\n}\n\n/* ==========================================================================\n   FEED & RECOMMENDATIONS\n   ========================================================================== */\n\n.ev-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.ev-section-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-main);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  letter-spacing: -0.01em;\n}\n\n.ev-section-count {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  background: var(--glass-bg);\n  padding: 0.2rem 0.6rem;\n  border-radius: 8px;\n  border: 1px solid var(--glass-border);\n}\n\n[data-theme='light'] .ev-section-count {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n}\n\n.ev-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1rem;\n}\n\n@media (max-width: 640px) {\n  .ev-cards-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.match-reasons {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  margin-top: 0.75rem;\n}\n\n.match-reason {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n}\n\n.match-reason .reason-icon {\n  color: var(--ev-green);\n  flex-shrink: 0;\n}\n\n.completion-ring-wrapper {\n  position: relative;\n  width: 72px;\n  height: 72px;\n  flex-shrink: 0;\n}\n\n.completion-ring-wrapper svg {\n  transform: rotate(-90deg);\n}\n\n.completion-ring-bg {\n  fill: none;\n  stroke: var(--glass-border);\n  stroke-width: 5;\n}\n\n.completion-ring-fill {\n  fill: none;\n  stroke: var(--ev-primary);\n  stroke-width: 5;\n  stroke-linecap: round;\n  transition: stroke-dashoffset 0.8s ease;\n}\n\n.completion-ring-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--text-main);\n  text-align: center;\n}\n\n/* Search bar */\n.ev-search-wrapper {\n  position: relative;\n}\n\n.ev-search-icon {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted);\n  pointer-events: none;\n}\n\n.ev-search-input {\n  width: 100%;\n  padding: 0.8rem 1rem 0.8rem 2.6rem;\n  background: var(--input-bg);\n  border: 1px solid var(--input-border);\n  border-radius: 12px;\n  color: var(--input-text);\n  font-size: 0.92rem;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.ev-search-input:focus {\n  outline: none;\n  border-color: var(--ev-primary);\n  box-shadow: 0 0 0 2px var(--ev-primary-muted);\n}\n\n.ev-search-input::placeholder {\n  color: var(--input-placeholder);\n}\n\n/* Stats */\n.ev-stats-bar {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.75rem;\n}\n\n.ev-stat-card {\n  background: var(--glass-bg);\n  border: 1px solid var(--glass-border);\n  border-radius: 14px;\n  padding: 0.9rem;\n  text-align: center;\n}\n\n.ev-stat-number {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.ev-stat-label {\n  font-size: 0.72rem;\n  color: var(--text-muted);\n  font-weight: 500;\n  margin-top: 0.15rem;\n}\n\n[data-theme='light'] .ev-stat-card {\n  background: #ffffff;\n  border-color: #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n/* Toast */\n.ev-toast {\n  position: fixed;\n  top: 1.5rem;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  z-index: 1200;\n  max-width: 440px;\n  width: calc(100% - 2rem);\n  padding: 0.85rem 1.15rem;\n  border-radius: 12px;\n  background: #0f172a;\n  color: white;\n  font-weight: 500;\n  font-size: 0.88rem;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.35);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n}\n\n/* Avatars */\n.ev-avatar {\n  border-radius: 50%;\n  object-fit: cover;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  color: white;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.ev-avatar-lg {\n  width: 56px;\n  height: 56px;\n  font-size: 1.25rem;\n}\n\n.ev-avatar-sm {\n  width: 38px;\n  height: 38px;\n  font-size: 0.85rem;\n}\n\n.ev-avatar-gradient-0 { background: #3b82f6; }\n.ev-avatar-gradient-1 { background: #6366f1; }\n.ev-avatar-gradient-2 { background: #0d9488; }\n.ev-avatar-gradient-3 { background: #d97706; }\n.ev-avatar-gradient-4 { background: #475569; }\n\n/* Mobile navigation */\n.events-mobile-nav {\n  display: none;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 60px;\n  background: var(--dropdown-bg);\n  backdrop-filter: blur(20px);\n  border-top: 1px solid var(--glass-border);\n  z-index: 100;\n  padding: 0 1rem;\n  align-items: center;\n  justify-content: space-around;\n}\n\n@media (max-width: 768px) {\n  .events-mobile-nav {\n    display: flex;\n  }\n  .events-wrapper {\n    padding: 1rem;\n    padding-bottom: 5rem;\n  }\n  .ev-cards-grid {\n    grid-template-columns: 1fr;\n  }\n  .ev-form-row {\n    grid-template-columns: 1fr;\n  }\n  .ev-stats-bar {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .ev-modal {\n    max-height: 95vh;\n  }\n  .ev-modal-body {\n    padding: 1rem 1.25rem;\n  }\n  .ev-modal-header {\n    padding: 1.15rem 1.25rem 0.75rem;\n  }\n  .ev-modal-footer {\n    padding: 0.75rem 1.25rem 1.15rem;\n  }\n  .skill-split {\n    grid-template-columns: 1fr;\n  }\n  .skill-split-divider {\n    display: none;\n  }\n}\n\n.mobile-nav-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.2rem;\n  color: var(--text-muted);\n  font-size: 0.65rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: color 0.2s;\n  padding: 0.5rem;\n  background: none;\n  border: none;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.mobile-nav-item.active {\n  color: var(--ev-primary);\n}\n\n.mobile-nav-item svg {\n  width: 20px;\n  height: 20px;\n}\n\n/* ==========================================================================\n   CONVERGENCE EXTERNAL PARTICIPANT & CTA STYLING (High-Contrast Light & Dark)\n   ========================================================================== */\n\n.ev-btn-external {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  width: 100%;\n  padding: 0.95rem 1.35rem;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  box-sizing: border-box;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);\n  color: #ffffff !important;\n  border: 1px solid #7c3aed;\n  box-shadow: 0 4px 18px rgba(124, 58, 237, 0.35);\n}\n\n.ev-btn-external:hover {\n  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(124, 58, 237, 0.5);\n  color: #ffffff !important;\n}\n\n.ev-btn-external:active {\n  transform: translateY(0);\n}\n\n.ev-divider-or {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  margin: 0.25rem 0.5rem;\n}\n\n.ev-divider-or-line {\n  flex: 1;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.18);\n}\n\n[data-theme='light'] .ev-divider-or-line {\n  background: #cbd5e1;\n}\n\n.ev-divider-or-text {\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  padding: 0.25rem 0.75rem;\n  border-radius: 999px;\n  color: var(--text-secondary, #94a3b8);\n  background: var(--glass-bg, rgba(255, 255, 255, 0.06));\n  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.15));\n}\n\n[data-theme='light'] .ev-divider-or-text {\n  color: #334155;\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n/* External Attendee Badges */\n.ev-badge-external {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.74rem;\n  font-weight: 700;\n  padding: 0.2rem 0.65rem;\n  border-radius: 8px;\n  background: #7c3aed;\n  color: #ffffff !important;\n  box-shadow: 0 2px 8px rgba(124, 58, 237, 0.3);\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n[data-theme='light'] .ev-badge-external {\n  background: #7c3aed;\n  color: #ffffff !important;\n}\n\n.ev-badge-internal {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.74rem;\n  font-weight: 700;\n  padding: 0.2rem 0.65rem;\n  border-radius: 8px;\n  background: rgba(37, 99, 235, 0.15);\n  color: #3b82f6;\n  border: 1px solid rgba(37, 99, 235, 0.3);\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n[data-theme='light'] .ev-badge-internal {\n  background: #eff6ff;\n  color: #1d4ed8;\n  border-color: #bfdbfe;\n}\n\n/* ==========================================================================\n   FLOATING ACTION & SCROLL GUIDANCE (Landing Page)\n   ========================================================================== */\n.ev-floating-scroll-guide {\n  position: fixed;\n  bottom: 2rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 90;\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.75rem 1.4rem;\n  background: rgba(15, 23, 42, 0.92);\n  backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 9999px;\n  color: #ffffff;\n  font-size: 0.88rem;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.08);\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  animation: ev-pulse-subtle 2.5s infinite;\n}\n\n.ev-floating-scroll-guide:hover {\n  transform: translateX(-50%) translateY(-3px);\n  background: #1e293b;\n  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.6), 0 0 20px rgba(37, 99, 235, 0.3);\n  border-color: rgba(59, 130, 246, 0.5);\n}\n\n@keyframes ev-pulse-subtle {\n  0%, 100% {\n    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5);\n  }\n  50% {\n    box-shadow: 0 14px 36px rgba(37, 99, 235, 0.25), 0 0 0 4px rgba(37, 99, 235, 0.12);\n  }\n}\n\n/* ==========================================================================\n   IMMERSIVE PROFILE PREVIEW DRAWER (Desktop slide-right / Mobile sheet)\n   ========================================================================== */\n.ev-drawer-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(4, 7, 14, 0.72);\n  backdrop-filter: blur(6px);\n  z-index: 1100;\n  display: flex;\n  justify-content: flex-end;\n  overflow: hidden;\n}\n\n.ev-drawer {\n  width: 100%;\n  max-width: 580px;\n  height: 100%;\n  background: #0b0f19;\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: -16px 0 48px rgba(0, 0, 0, 0.6);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n  z-index: 1101;\n}\n\n[data-theme='light'] .ev-drawer {\n  background: #ffffff;\n  border-left-color: #e2e8f0;\n  box-shadow: -12px 0 36px rgba(0, 0, 0, 0.1);\n}\n\n.ev-drawer-header {\n  padding: 1.25rem 1.75rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(12px);\n  flex-shrink: 0;\n}\n\n[data-theme='light'] .ev-drawer-header {\n  border-bottom-color: #f1f5f9;\n  background: #f8fafc;\n}\n\n.ev-drawer-nav-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.ev-drawer-nav-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.75rem;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: var(--text-main);\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.ev-drawer-nav-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.ev-drawer-nav-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.ev-drawer-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.75rem;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.15) transparent;\n}\n\n.ev-drawer-hero {\n  display: flex;\n  gap: 1.25rem;\n  align-items: flex-start;\n}\n\n.ev-drawer-avatar {\n  width: 76px;\n  height: 76px;\n  border-radius: 20px;\n  object-fit: cover;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: #ffffff;\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n}\n\n.ev-drawer-title-group {\n  flex: 1;\n  min-width: 0;\n}\n\n.ev-drawer-name {\n  font-size: 1.4rem;\n  font-weight: 800;\n  color: var(--text-main);\n  margin: 0;\n  line-height: 1.2;\n}\n\n.ev-drawer-sub {\n  font-size: 0.88rem;\n  color: var(--text-secondary);\n  margin-top: 0.35rem;\n}\n\n.ev-drawer-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.ev-drawer-section-title {\n  font-size: 0.76rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--text-muted);\n}\n\n.ev-chip-cloud {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n}\n\n.ev-skill-pill {\n  padding: 0.35rem 0.75rem;\n  border-radius: 8px;\n  font-size: 0.82rem;\n  font-weight: 500;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: var(--text-main);\n}\n\n.ev-skill-pill.highlight {\n  background: rgba(37, 99, 235, 0.15);\n  border-color: rgba(37, 99, 235, 0.35);\n  color: #93c5fd;\n  font-weight: 600;\n}\n\n.ev-drawer-footer {\n  padding: 1.25rem 1.75rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(15, 23, 42, 0.5);\n  backdrop-filter: blur(12px);\n  display: flex;\n  gap: 0.75rem;\n  flex-shrink: 0;\n}\n\n@media (max-width: 768px) {\n  .ev-drawer-backdrop {\n    align-items: flex-end;\n  }\n  .ev-drawer {\n    max-width: 100%;\n    height: 90vh;\n    border-radius: 24px 24px 0 0;\n    border-left: none;\n    border-top: 1px solid rgba(255, 255, 255, 0.15);\n  }\n}\n\n/* ==========================================================================\n   NETWORKING STATS METRIC CARDS\n   ========================================================================== */\n.ev-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.15rem;\n  margin-bottom: 2rem;\n}\n\n@media (max-width: 1024px) {\n  .ev-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .ev-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.75rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .ev-stat-card {\n    aspect-ratio: 1 / 1;\n    padding: 0.95rem;\n    border-radius: 16px;\n    justify-content: space-between;\n    gap: 0.35rem;\n  }\n\n  .ev-stat-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.35rem;\n    width: 100%;\n  }\n\n  .ev-stat-label {\n    font-size: 0.78rem;\n    font-weight: 700;\n    line-height: 1.2;\n  }\n\n  .ev-stat-badge {\n    font-size: 0.6rem;\n    padding: 0.12rem 0.4rem;\n  }\n\n  .ev-stat-number-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.25rem;\n    width: 100%;\n  }\n\n  .ev-stat-number {\n    font-size: 1.95rem;\n    font-weight: 900;\n  }\n\n  .ev-stat-mini-progress {\n    width: 100%;\n    height: 4px;\n  }\n\n  .ev-stat-footer {\n    display: none;\n  }\n}\n\n.ev-stat-card {\n  background: var(--glass-bg);\n  border: 1px solid var(--glass-border);\n  border-radius: 18px;\n  padding: 1.2rem 1.35rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 0.85rem;\n  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.ev-stat-card:hover {\n  transform: translateY(-2px);\n  border-color: rgba(255, 255, 255, 0.22);\n  box-shadow: 0 12px 24px -6px rgba(0, 0, 0, 0.35);\n}\n\n[data-theme='light'] .ev-stat-card {\n  background: #ffffff;\n  border-color: #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n[data-theme='light'] .ev-stat-card:hover {\n  border-color: #cbd5e1;\n  box-shadow: 0 10px 20px -4px rgba(0, 0, 0, 0.08);\n}\n\n.ev-stat-card.active-stat {\n  border-color: var(--ev-primary);\n  background: rgba(37, 99, 235, 0.08);\n}\n\n.ev-stat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.ev-stat-label {\n  font-size: 0.84rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: capitalize;\n  letter-spacing: -0.01em;\n}\n\n.ev-stat-badge {\n  font-size: 0.68rem;\n  font-weight: 700;\n  padding: 0.2rem 0.55rem;\n  border-radius: 6px;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.ev-stat-badge-blue {\n  background: rgba(37, 99, 235, 0.14);\n  color: #60a5fa;\n  border: 1px solid rgba(37, 99, 235, 0.28);\n}\n\n.ev-stat-badge-green {\n  background: rgba(34, 197, 94, 0.14);\n  color: #4ade80;\n  border: 1px solid rgba(34, 197, 94, 0.28);\n}\n\n.ev-stat-badge-amber {\n  background: rgba(245, 158, 11, 0.14);\n  color: #fbbf24;\n  border: 1px solid rgba(245, 158, 11, 0.28);\n}\n\n.ev-stat-badge-purple {\n  background: rgba(168, 85, 247, 0.14);\n  color: #c084fc;\n  border: 1px solid rgba(168, 85, 247, 0.28);\n}\n\n.ev-stat-badge-cyan {\n  background: rgba(6, 182, 212, 0.14);\n  color: #22d3ee;\n  border: 1px solid rgba(6, 182, 212, 0.28);\n}\n\n.ev-stat-number-row {\n  display: flex;\n  align-items: baseline;\n  gap: 0.85rem;\n}\n\n.ev-stat-number {\n  font-size: 2.25rem;\n  font-weight: 900;\n  letter-spacing: -0.04em;\n  color: var(--text-main);\n  line-height: 1;\n}\n\n.ev-stat-mini-progress {\n  flex: 1;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 999px;\n  overflow: hidden;\n  align-self: center;\n}\n\n[data-theme='light'] .ev-stat-mini-progress {\n  background: #e2e8f0;\n}\n\n.ev-stat-mini-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #2563eb, #38bdf8);\n  border-radius: 999px;\n  transition: width 0.4s ease;\n}\n\n.ev-stat-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  padding-top: 0.65rem;\n}\n\n[data-theme='light'] .ev-stat-footer {\n  border-top-color: #f1f5f9;\n}\n\n.ev-stat-action {\n  color: var(--ev-primary);\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n/* ==========================================================================\n   FEATURED RECOMMENDATION HERO STORY\n   ========================================================================== */\n.ev-featured-rec {\n  background: linear-gradient(135deg, rgba(30, 41, 59, 0.6) 0%, rgba(15, 23, 42, 0.8) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 20px;\n  padding: 1.75rem;\n  margin-bottom: 2.25rem;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 16px 36px -10px rgba(0, 0, 0, 0.45);\n  transition: border-color 0.25s;\n}\n\n.ev-featured-rec:hover {\n  border-color: rgba(59, 130, 246, 0.4);\n}\n\n[data-theme='light'] .ev-featured-rec {\n  background: #ffffff;\n  border-color: #e2e8f0;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);\n}\n\n.ev-featured-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.74rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #60a5fa;\n  margin-bottom: 1rem;\n}\n\n.ev-featured-layout {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 1.5rem;\n  align-items: center;\n}\n\n@media (max-width: 768px) {\n  .ev-featured-layout {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n}\n\n/* ==========================================================================\n   REFINED PERSON DISCOVERY CARDS (Original Editorial Look)\n   ========================================================================== */\n.ev-person-card {\n  background: var(--glass-bg);\n  border: 1px solid var(--glass-border);\n  border-radius: 18px;\n  padding: 1.35rem 1.4rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 1.15rem;\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n  position: relative;\n}\n\n.ev-person-card:hover {\n  transform: translateY(-3px);\n  border-color: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 14px 28px -6px rgba(0, 0, 0, 0.45);\n}\n\n[data-theme='light'] .ev-person-card {\n  background: #ffffff;\n  border-color: #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n[data-theme='light'] .ev-person-card:hover {\n  border-color: #cbd5e1;\n  box-shadow: 0 12px 24px -4px rgba(0, 0, 0, 0.08);\n}\n\n.ev-person-top {\n  display: flex;\n  gap: 0.9rem;\n  align-items: flex-start;\n}\n\n.ev-person-name {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--text-main);\n  line-height: 1.25;\n  margin: 0;\n}\n\n.ev-person-meta {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  margin-top: 0.25rem;\n}\n\n.ev-why-match-box {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 10px;\n  padding: 0.65rem 0.85rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n[data-theme='light'] .ev-why-match-box {\n  background: #f8fafc;\n  border-color: #f1f5f9;\n}\n\n.ev-why-match-item {\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.ev-compat-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  padding: 0.2rem 0.55rem;\n  border-radius: 6px;\n  background: rgba(37, 99, 235, 0.12);\n  color: #60a5fa;\n  border: 1px solid rgba(37, 99, 235, 0.25);\n}\n\n/* ==========================================================================\n   7-STEP ONBOARDING JOURNEY\n   ========================================================================== */\n.ev-onboard-wrapper {\n  max-width: 680px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.ev-onboard-header {\n  margin-bottom: 1.5rem;\n}\n\n.ev-onboard-progress-bar {\n  width: 100%;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 2px;\n  overflow: hidden;\n  margin-top: 1rem;\n}\n\n.ev-onboard-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #2563eb, #7c3aed);\n  transition: width 0.35s ease;\n}\n\n.ev-interest-cluster-title {\n  font-size: 0.74rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--text-muted);\n  margin: 1.25rem 0 0.5rem;\n}\n\n.ev-interest-cluster-title:first-child {\n  margin-top: 0;\n}\n\n.ev-interest-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.ev-selectable-card {\n  padding: 0.5rem 0.95rem;\n  border-radius: 10px;\n  border: 1px solid var(--glass-border);\n  background: var(--glass-bg);\n  color: var(--text-secondary);\n  font-size: 0.84rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.ev-selectable-card:hover {\n  border-color: rgba(255, 255, 255, 0.25);\n  color: var(--text-main);\n  transform: translateY(-1px);\n}\n\n.ev-selectable-card.selected {\n  background: rgba(37, 99, 235, 0.16);\n  border-color: #3b82f6;\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: 0 0 14px rgba(37, 99, 235, 0.25);\n}\n\n[data-theme='light'] .ev-selectable-card.selected {\n  background: #eff6ff;\n  border-color: #2563eb;\n  color: #1e40af;\n}\n\n.ev-onboard-review-box {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.15rem;\n}\n\n.ev-review-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.ev-review-label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-muted);\n}\n\n.ev-review-value {\n  font-size: 0.92rem;\n  color: var(--text-main);\n  font-weight: 500;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
